import React, { useState } from 'react';
import { CheckIcon, AlertCircleIcon } from 'lucide-react';
interface BankAccountVerificationProps {
  onNext: () => void;
}
const BankAccountVerification: React.FC<BankAccountVerificationProps> = ({
  onNext
}) => {
  const [accountName, setAccountName] = useState('');
  const [bsb, setBsb] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [isPennyTestInitiated, setIsPennyTestInitiated] = useState(false);
  const [pennyTestAmount, setPennyTestAmount] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const handleInitiatePennyTest = () => {
    // In a real app, this would call an API to initiate a penny test
    setIsPennyTestInitiated(true);
  };
  const handleVerifyPennyTest = () => {
    // In a real app, this would verify the penny test amount with the backend
    if (pennyTestAmount === '0.01') {
      setIsVerified(true);
    } else {
      alert('Incorrect amount. Please check your bank account and try again.');
    }
  };
  return <div className="space-y-6" data-id="element-664">
      <div data-id="element-665">
        <h2 className="text-lg font-medium text-gray-900" data-id="element-666">
          Bank Account Verification
        </h2>
        <p className="mt-1 text-sm text-gray-500" data-id="element-667">
          Add your business bank account details for receiving payments.
        </p>
      </div>
      <div className="space-y-4" data-id="element-668">
        <div data-id="element-669">
          <label htmlFor="account-name" className="block text-sm font-medium text-gray-700" data-id="element-670">
            Account Name
          </label>
          <input type="text" name="account-name" id="account-name" value={accountName} onChange={e => setAccountName(e.target.value)} disabled={isVerified} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-671" />
        </div>
        <div data-id="element-672">
          <label htmlFor="bsb" className="block text-sm font-medium text-gray-700" data-id="element-673">
            BSB
          </label>
          <input type="text" name="bsb" id="bsb" value={bsb} onChange={e => setBsb(e.target.value)} disabled={isVerified} placeholder="e.g. 123-456" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-674" />
        </div>
        <div data-id="element-675">
          <label htmlFor="account-number" className="block text-sm font-medium text-gray-700" data-id="element-676">
            Account Number
          </label>
          <input type="text" name="account-number" id="account-number" value={accountNumber} onChange={e => setAccountNumber(e.target.value)} disabled={isVerified} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-677" />
        </div>
      </div>
      {!isPennyTestInitiated && !isVerified && <div className="rounded-md bg-blue-50 p-4" data-id="element-678">
          <div className="flex" data-id="element-679">
            <div className="flex-shrink-0" data-id="element-680">
              <AlertCircleIcon className="h-5 w-5 text-blue-400" data-id="element-681" />
            </div>
            <div className="ml-3" data-id="element-682">
              <h3 className="text-sm font-medium text-blue-800" data-id="element-683">
                Bank account verification required
              </h3>
              <div className="mt-2 text-sm text-blue-700" data-id="element-684">
                <p data-id="element-685">
                  To verify your bank account, we'll send a small test deposit
                  (less than $1). Once you see this deposit in your account,
                  you'll need to confirm the exact amount to verify ownership.
                </p>
              </div>
              <div className="mt-4" data-id="element-686">
                <button type="button" onClick={handleInitiatePennyTest} disabled={!accountName || !bsb || !accountNumber} className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white ${!accountName || !bsb || !accountNumber ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'}`} data-id="element-687">
                  Initiate Verification
                </button>
              </div>
            </div>
          </div>
        </div>}
      {isPennyTestInitiated && !isVerified && <div className="rounded-md bg-yellow-50 p-4" data-id="element-688">
          <div className="flex" data-id="element-689">
            <div className="flex-shrink-0" data-id="element-690">
              <AlertCircleIcon className="h-5 w-5 text-yellow-400" data-id="element-691" />
            </div>
            <div className="ml-3" data-id="element-692">
              <h3 className="text-sm font-medium text-yellow-800" data-id="element-693">
                Verification in progress
              </h3>
              <div className="mt-2 text-sm text-yellow-700" data-id="element-694">
                <p data-id="element-695">
                  We've initiated a small test deposit to your bank account.
                  This may take 1-2 business days to appear in your account.
                  Once you see it, enter the exact amount below to verify your
                  account.
                </p>
                <div className="mt-4" data-id="element-696">
                  <label htmlFor="penny-test" className="block text-sm font-medium text-yellow-700" data-id="element-697">
                    Test Deposit Amount ($)
                  </label>
                  <div className="mt-1 flex rounded-md shadow-sm" data-id="element-698">
                    <input type="text" name="penny-test" id="penny-test" value={pennyTestAmount} onChange={e => setPennyTestAmount(e.target.value)} className="flex-1 min-w-0 block w-full px-3 py-2 rounded-md border border-yellow-300 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm" placeholder="e.g. 0.01" data-id="element-699" />
                    <button type="button" onClick={handleVerifyPennyTest} disabled={!pennyTestAmount} className={`ml-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white ${!pennyTestAmount ? 'bg-gray-300 cursor-not-allowed' : 'bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500'}`} data-id="element-700">
                      Verify Amount
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
      {isVerified && <div className="rounded-md bg-green-50 p-4" data-id="element-701">
          <div className="flex" data-id="element-702">
            <div className="flex-shrink-0" data-id="element-703">
              <CheckIcon className="h-5 w-5 text-green-400" data-id="element-704" />
            </div>
            <div className="ml-3" data-id="element-705">
              <h3 className="text-sm font-medium text-green-800" data-id="element-706">
                Bank account verified
              </h3>
              <div className="mt-2 text-sm text-green-700" data-id="element-707">
                <p data-id="element-708">
                  Your bank account has been successfully verified and is ready
                  to receive payments.
                </p>
              </div>
            </div>
          </div>
        </div>}
      <div className="pt-5" data-id="element-709">
        <div className="flex justify-end" data-id="element-710">
          <button type="button" disabled={!isVerified} onClick={onNext} className={`ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white ${!isVerified ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'}`} data-id="element-711">
            Next Step
          </button>
        </div>
      </div>
    </div>;
};
export default BankAccountVerification;